<template>
  <div>
    <top-bar heading="Edit Form"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3 digido-form-builder" v-if="loaded">
      <b-card header="Form Settings" no-body>
        <b-card-body class="p-3">
          <div class="row mb-3">
            <div class="col">
              <label class="control-label visible-ie8 visible-ie9" for="form_name">Form Name</label>
              <input
                      :class="{'form-control': true, 'is-invalid': errors.has('form_name')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Form Name"
                      data-vv-name="form_name"
                      type="text"
                      placeholder="Form Name"
                      name="form_name"
                      id="form_name"
                      v-model="form.name"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('form_name')">{{ errors.first('form_name') }}</div>
            </div>
            <div class="col">
              <label class="control-label visible-ie8 visible-ie9 d-block" for="form_type">Form Type</label>
              <b-form-radio-group v-model="form.form_type"
                                  buttons
                                  button-variant="outline-primary"
                                  class="w-100"
                                  :options="{1: 'Assignment', 2: 'Learning Activity', 3: 'Signoff Form', 5: 'Document', 4: 'Other'}"
                                  v-validate="'required'"
                                  data-vv-delay="500"
                                  data-vv-as="Form Type"
                                  data-vv-name="form_type"
                                  name="form_type"
                                  id="form_type"
              ></b-form-radio-group>
              <div class="invalid-tooltip d-block" v-if="errors.has('form_type')">{{ errors.first('form_type') }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label class="control-label visible-ie8 visible-ie9" for="form_status">Form Status</label>
              <select :class="{'form-control': true, 'is-invalid': errors.has('form_status')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Form Status"
                      data-vv-name="form_status"
                      name="form_status"
                      id="form_status"
                      v-model="form.published"
                      :disabled="!$auth.check('super_admin')">
                <option :value="0">Draft</option>
                <option :value="1">Published</option>
              </select>
              <div class="invalid-tooltip d-block" v-if="errors.has('form_status')">{{ errors.first('form_status') }}</div>
            </div>
            <div class="col" v-if="form.form_type !== 3">
              <label class="control-label visible-ie8 visible-ie9" for="form_status">Form Display</label>
              <select :class="{'form-control': true, 'is-invalid': errors.has('form_display')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Form Display"
                      data-vv-name="form_display"
                      name="form_display"
                      id="form_display"
                      v-model="form.schema.display">
                <option value="form">Form</option>
                <!--                <option value="wizard">Wizard</option>-->
                <option value="pdf">PDF</option>
              </select>
              <div class="invalid-tooltip d-block" v-if="errors.has('form_status')">{{ errors.first('form_status') }}</div>
            </div>
            <div class="col">
              <label>&nbsp;</label>
              <loading-button :loading="loading" block @submit="saveForm">Save Form</loading-button>
            </div>
          </div>
          <div class="row" v-if="form.schema.display === 'pdf'">
            <div class="col">
              <label class="control-label visible-ie8 visible-ie9" for="form_status">Form PDF</label>
              <b-form-file
                      v-model="file"
                      :state="Boolean(file)"
              >

              </b-form-file>
            </div>
          </div>
        </b-card-body>
      </b-card>
      <b-card no-body v-if="loaded && form.form_type !== 3">
        <b-card-body class="pr-3 bg-transparent" :key="form.id + '-' + form.schema.display">
          <template v-if="form.schema.display !== 'pdf'">
            <default-form v-model="form.schema"></default-form>
          </template>
          <template v-else>
            <template v-if="form.schema.settings.pdf && form.schema.settings.pdf.id">
              <default-form v-model="form.schema"></default-form>
            </template>
            <template v-else>
              <div class="p-3 text-center">
                <h3>Please upload a PDF and save first.</h3>
              </div>
            </template>
          </template>
        </b-card-body>
      </b-card>
      <b-card no-body header="Edit Form" v-if="loaded && form.form_type === 3">
        <b-card-body class="pr-3">
          <b-card no-body>
            <b-tabs lazy>
              <b-tab title="Assessor" active>
                <default-form v-model="form.schema.assessor"></default-form>
              </b-tab>
              <b-tab title="Student">
                <default-form v-model="form.schema.student"></default-form>
              </b-tab>
              <b-tab title="Supervisor">
                <default-form v-model="form.schema.supervisor"></default-form>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>

import DefaultForm from '../../components/FormEditor/DefaultForm'

export default {
  name: 'EditForm',
  components: { DefaultForm },
  data () {
    return {
      loaded: false,
      loading: false,
      form: {
        schema: {
          settings: {
            pdf: {}
          }
        }
      },
      formApi: null,
      file: null
    }
  },
  methods: {
    getForm () {
      this.loaded = false
      this.axios.get('/forms/' + this.id).then(rsp => {
        this.form = rsp.data
        this.loaded = true
      })
    },
    saveForm () {
      this.loading = true
      this.loaded = false

      const formData = new FormData()
      formData.append('_method', 'PUT')
      Object.keys(this.form).forEach(key => {
        if(typeof this.form[key] === 'object') {
          formData.append(key, JSON.stringify(this.form[key]))
        } else {
          formData.append(key, this.form[key])
        }
      })


      if (this.file) {
        console.log(this.file)
        formData.append('pdf', this.file)
        this.file = null
      }

      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }

      this.axios.post('/forms/' + this.id, formData, config).then(rsp => {
        this.$snotify.success('Saved Form')
        this.form = rsp.data
        this.loading = false
        this.loaded = true
      })
    }
  },
  mounted () {
    this.getForm()
  },
  metaInfo: {
    title: 'Edit Form'
  },
  props: ['id']
}
</script>

<style lang="scss">
  .digido-form-builder {
    @import "~formiojs/dist/formio.builder.css";

    .builder-group-button {
      color: white !important;
    }

    .form-builder-panel {
      min-height: 10px;
    }

  }
</style>
